import { Box, Container } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useProfile } from './api/queries';
import { Nav } from './components/Nav';
import AdminAdmins from './pages/admin/AdminAdmins';
import AdminApps from './pages/admin/AdminApps';
import AdminAudit from './pages/admin/AdminAudit';
import AdminCategories from './pages/admin/AdminCategories';
import AdminHR from './pages/admin/AdminHR';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOverrides from './pages/admin/AdminOverrides';
import AdminRequests from './pages/admin/AdminRequests';
import AdminSummary from './pages/admin/AdminSummary';
import Browse from './pages/Browse';
import MyRequests from './pages/MyRequests';
import NotFound from './pages/NotFound';

export default function App() {
  const { data: profile, isLoading: profileLoading } = useProfile();
  const isAdmin = profile?.isAdmin ?? false;

  return (
    <Box className="min-h-screen flex flex-col">
      <Nav isAdmin={isAdmin} />
      {/* Constrained, centered width — easier to scan a row left-to-right than
          full-bleed on a wide monitor. */}
      <Container maxWidth="lg" className="flex-1 py-8 px-6">
        <Routes>
          <Route path="/" element={<Browse />} />
          <Route path="/my-requests" element={<MyRequests />} />
          {/* Deep links to /admin/* must not bounce while the profile is
              still loading — hold the route until we know who's asking. */}
          <Route
            path="/admin"
            element={
              profileLoading ? null : isAdmin ? <AdminLayout /> : <Navigate to="/" replace />
            }
          >
            <Route index element={<Navigate to="summary" replace />} />
            <Route path="summary" element={<AdminSummary />} />
            <Route path="apps" element={<AdminApps />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="requests" element={<AdminRequests />} />
            <Route path="admins" element={<AdminAdmins />} />
            <Route path="overrides" element={<AdminOverrides />} />
            <Route path="hr" element={<AdminHR />} />
            <Route path="activity" element={<AdminAudit />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Container>
    </Box>
  );
}
